// Complete States & Union Territories of India with District/Town mappings

export const INDIAN_STATES_DISTRICTS = {
  "MAHARASHTRA": [
    "AHMEDNAGAR (AHILYANAGAR)", "AKOLA", "AMRAVATI", "AURANGABAD (CHHATRAPATI SAMBHAJINAGAR)",
    "BEED", "BHANDARA", "BULDHANA", "CHANDRAPUR", "DHULE", "GADCHIROLI",
    "GONDIA", "HINGOLI", "JALGAON", "JALNA", "KOLHAPUR", "LATUR",
    "MUMBAI CITY", "MUMBAI SUBURBAN", "NAGPUR", "NANDED", "NANDURBAR",
    "NASHIK", "OSMANABAD (DHARASHIV)", "PALGHAR", "PARBHANI", "PUNE",
    "RAIGAD", "RATNAGIRI", "SANGLI", "SATARA", "SINDHUDURG", "SOLAPUR",
    "THANE", "WARDHA", "WASHIM", "YAVATMAL"
  ],
  "KARNATAKA": [
    "BAGALKOTE", "BALLARI", "BELAGAVI", "BENGALURU RURAL", "BENGALURU URBAN",
    "BIDAR", "CHAMARAJANAGARA", "CHIKKABALLAPURA", "CHIKKAMAGALURU", "CHITRADURGA",
    "DAKSHINA KANNADA", "DAVANAGERE", "DHARWAD", "GADAG", "HASSAN",
    "HAVERI", "KALABURAGI", "KODAGU", "KOLAR", "KOPPAL",
    "MANDYA", "MYSURU", "RAICHUR", "RAMANAGARA", "SHIVAMOGGA",
    "TUMAKURU", "UDUPI", "UTTARA KANNADA", "VIJAYAPURA", "VIJAYANAGARA", "YADGIR"
  ],
  "GUJARAT": [
    "AHMEDABAD", "AMRELI", "ANAND", "ARAVALLI", "BANASKANTHA",
    "BHARUCH", "BHAVNAGAR", "BOTAD", "CHHOTAUDEPUR", "DAHOD",
    "DANG", "DEVBHUMI DWARKA", "GANDHINAGAR", "GIR SOMNATH", "JAMNAGAR",
    "JUNAGADH", "KHEDA", "KUTCH", "MAHISAGAR", "MEHSANA",
    "MORBI", "NARMADA", "NAVSARI", "PANCHMAHAL", "PATAN",
    "PORBANDAR", "RAJKOT", "SABARKANTHA", "SURAT", "SURENDRANAGAR",
    "TAPI", "VADODARA", "VALSAD"
  ],
  "DELHI": [
    "CENTRAL DELHI", "EAST DELHI", "NEW DELHI", "NORTH DELHI",
    "NORTH EAST DELHI", "NORTH WEST DELHI", "SHAH DARA", "SOUTH DELHI",
    "SOUTH EAST DELHI", "SOUTH WEST DELHI", "WEST DELHI"
  ],
  "UTTAR PRADESH": [
    "AGRA", "ALIGARH", "AMBEDKAR NAGAR", "AMETHI", "AMROHA",
    "AURAIYA", "AYODHYA", "AZAMGARH", "BAGHPAT", "BAHRAICH",
    "BALLIA", "BALRAMPUR", "BANDA", "BARABANKI", "BAREILLY",
    "BASTI", "BHADOHI", "BIJNOR", "BUDAUN", "BULANDSHAHR",
    "CHANDAULI", "CHITRAKOOT", "DEORIA", "ETAH", "ETAWAH",
    "FARRUKHABAD", "FATEHPUR", "FIROZABAD", "GHAUTAM BUDDHA NAGAR (NOIDA)", "GHAZIABAD",
    "GHAZIPUR", "GONDA", "GORAKHPUR", "HAMIRPUR", "HAPUR",
    "HARDOI", "HATHRAS", "JALAUN", "JAUNPUR", "JHANSI",
    "KANNAUJ", "KANPUR DEHAT", "KANPUR NAGAR", "KASGANJ", "KAUSHAMBI",
    "KUSHI NAGAR", "LAKHIMPUR KHERI", "LALITPUR", "LUCKNOW", "MAHARAJGANJ",
    "MAHOBA", "MAINPURI", "MATHURA", "MAU", "MEERUT",
    "MIRZAPUR", "MORADABAD", "MUZAFFARNAGAR", "PILIBHIT", "PRATAPGARH",
    "PRAYAGRAJ (ALLAHABAD)", "RAE BARELI", "RAMPUR", "SAHARANPUR", "SAMBHAL",
    "SANT KABIR NAGAR", "SHAHJAHANPUR", "SHAMLI", "SHRAVASTI", "SIDDHARTHNAGAR",
    "SITAPUR", "SONBHADRA", "SULTANPUR", "UNNAO", "VARANASI"
  ],
  "MADHYA PRADESH": [
    "AGAR MALWA", "ALIRAJPUR", "ANUPPUR", "ASHOKNAGAR", "BALAGHAT",
    "BARWANI", "BETUL", "BHIND", "BHOPAL", "BURHANPUR",
    "CHHATARPUR", "CHHINDWARA", "DAMOH", "DATIA", "DEWAS",
    "DHAR", "DINDORI", "GUNA", "GWALIOR", "HARDA",
    "NARMADAPURAM (HOSHANGABAD)", "INDORE", "JABALPUR", "JHABUA", "KATNI",
    "KHANDWA", "KHARGONE", "MANDLA", "MANDSAUR", "MORENA",
    "NARSINGHPUR", "NEEMUCH", "PANNA", "RAISEN", "RAJGARH",
    "RATLAM", "REWA", "SAGAR", "SATNA", "SEHORE",
    "SEONI", "SHAHDOL", "SHAJAPUR", "SHEOPUR", "SHIVPURI",
    "SIDHI", "SINGRAULI", "TIKAMGARH", "UJJAIN", "UMARIA", "VIDISHA"
  ],
  "TAMIL NADU": [
    "ARIYALUR", "CHENGALPATTU", "CHENNAI", "COIMBATORE", "CUDDALORE",
    "DHARMAPURI", "DINDIGUL", "ERODE", "KANCHEEPURAM", "KANYAKUMARI",
    "KARUR", "KRISHNAGIRI", "MADURAI", "MAYILADUTHURAI", "NAGAPATTINAM",
    "NAMAKKAL", "NILGIRIS", "PERAMBALUR", "PUDUKKOTTAI", "RAMANATHAPURAM",
    "RANIPET", "SALEM", "SIVAGANGA", "TENKASI", "THANJAVUR",
    "THENI", "THOOTHUKUDI", "TIRUCHIRAPPALLI", "TIRUNELVELI", "TIRUPATHUR",
    "TIRUPPUR", "TIRUVALLUR", "TIRUVANNAMALAI", "TIRUVARUR", "VELLORE",
    "VILUPPURAM", "VIRUDHUNAGAR"
  ],
  "TELANGANA": [
    "ADILABAD", "BHADRADRI KOTHAGUDEM", "HYDERABAD", "JAGTIAL", "JANGAON",
    "JAYASHANKAR BHUPALPALLY", "JOGULAMBA GADWAL", "KAMAREDDY", "KARIMNAGAR", "KHAMMAM",
    "KOMARAM BHEEM ASIFABAD", "MAHABUBABAD", "MAHABUBNAGAR", "MANCHERIAL", "MEDAK",
    "MEDCHAL-MALKAJGIRI", "MULUGU", "NAGARKURNOOL", "NALGONDA", "NARAYANPET",
    "NIRMAL", "NIZAMABAD", "PEDDAPALLI", "RAJANNA SIRCILLA", "RANGAREDDY",
    "SANGAREDDY", "SIDDIPET", "SURYAPET", "VIKARABAD", "WANAPARTHY",
    "WARANGAL", "HANUMAKONDA", "YADADRI BHUVANAGIRI"
  ],
  "ANDHRA PRADESH": [
    "ALLURI SITHARAMA RAJU", "ANAKAPALLI", "ANANTHAPURAMU", "ANNAMAYYA", "BAPATLA",
    "CHITTOOR", "EAST GODAVARI", "ELURU", "GUNTUR", "KAKINADA",
    "KONASEEMA", "KRISHNA", "KURNOOL", "NANDYAL", "NTR",
    "PALNADU", "PARVATHIPURAM MANYAM", "PRAKASAM", "SRI POTTI SRIRAMULU NELLORE", "SRI SATHYA SAI",
    "SRIKAKULAM", "TIRUPATI", "VISAKHAPATNAM", "VIZIANAGARAM", "WEST GODAVARI", "YSR KADAPA"
  ],
  "WEST BENGAL": [
    "ALIPURDUAR", "BANKURA", "BIRBHUM", "COOCH BEHAR", "DAKSHIN DINAJPUR",
    "DARJEELING", "HOOGHLY", "HOWRAH", "JALPAIGURI", "JHARGRAM",
    "KALIMPONG", "KOLKATA", "MALDA", "MURSHIDABAD", "NADIA",
    "NORTH 24 PARGANAS", "PASCHIM BARDHAMAN", "PASCHIM MEDINIPUR", "PURBA BARDHAMAN", "PURBA MEDINIPUR",
    "PURULIA", "SOUTH 24 PARGANAS", "UTTAR DINAJPUR"
  ],
  "BIHAR": [
    "ARARIA", "ARWAL", "AURANGABAD", "BANKA", "BEGUSARAI",
    "BHAGALPUR", "BHOJPUR", "BUXAR", "DARBHANGA", "EAST CHAMPARAN",
    "GAYA", "GOPALGANJ", "JAMUI", "JEHANABAD", "KAIMUR",
    "KATIHAR", "KHAGARIA", "KISHANGANJ", "LAKHISARAI", "MADHEPURA",
    "MADHUBANI", "MUNGER", "MUZAFFARPUR", "NALANDA", "NAWADA",
    "PATNA", "PURNEA", "ROHTAS", "SAHARSA", "SAMASTIPUR",
    "SARAN", "SHEOHAR", "SHEIKHPURA", "SITAMARHI", "SIWAN",
    "SUPAUL", "VAISHALI", "WEST CHAMPARAN"
  ],
  "RAJASTHAN": [
    "AJMER", "ALWAR", "BANSWARA", "BARAN", "BARMER",
    "BHARATPUR", "BHILWARA", "BIKANER", "BUNDI", "CHITTORGARH",
    "CHURU", "DAUSA", "DHOLPUR", "DUNGARPUR", "HANUMANGARH",
    "JAIPUR", "JAISALMER", "JALORE", "JHALAWAR", "JHUNJHUNU",
    "JODHPUR", "KARAULI", "KOTA", "NAGAUR", "PALI",
    "PRATAPGARH", "RAJSAMAND", "SAWAI MADHOPUR", "SIKAR", "SIROHI",
    "SRI GANGANAGAR", "TONK", "UDAIPUR"
  ],
  "PUNJAB": [
    "AMRITSAR", "BARNALA", "BATHINDA", "FARIDKOT", "FATEHGARH SAHIB",
    "FAZILKA", "FIROZPUR", "GURDASPUR", "HOSHIARPUR", "JALANDHAR",
    "KAPURTHALA", "LUDHIANA", "MALEERKOTLA", "MANSA", "MOGA",
    "PATHANKOT", "PATIALA", "RUPNAGAR", "SAHIBZADA AJIT SINGH NAGAR (MOHALI)", "SANGRUR",
    "SHAHID BHAGAT SINGH NAGAR (NAWANSHAHR)", "SRI MUKTSAR SAHIB", "TARN TARAN"
  ],
  "HARYANA": [
    "AMBALA", "BHIWANI", "CHARKHI DADRI", "FARIDABAD", "FATEHABAD",
    "GURUGRAM", "HISAR", "JHAJJAR", "JIND", "KAITHAL",
    "KARNAL", "KURUKSHETRA", "MAHENDARGARH", "NUGH", "PALWAL",
    "PANCHKULA", "PANIPAT", "REWARI", "ROHTAK", "SIRSA",
    "SONIPAT", "YAMUNANAGAR"
  ],
  "KERALA": [
    "ALAPPUZHA", "ERNAKULAM (KOCHI)", "IDUKKI", "KANNUR", "KASARAGOD",
    "KOLLAM", "KOTTAYAM", "KOZHIKODE", "MALAPPURAM", "PALAKKAD",
    "PATHANAMTHITTA", "THIRUVANANTHAPURAM", "THRISSUR", "WAYANAD"
  ],
  "ODISHA": [
    "ANGUL", "BALANGIR", "BALASORE", "BARGARH", "BHADRAK",
    "BOUDH", "CUTTACK", "DEOGARH", "DHENKANAL", "GAJAPATI",
    "GANJAM", "JAGATSINGHPUR", "JAJPUR", "JHARSUGUDA", "KALAHANDI",
    "KANDHAMAL", "KENDRAPARA", "KENDUJHARA", "KHORDHA (BHUBANESWAR)", "KORAPUT",
    "MALKANGIRI", "MAYURBHANJ", "NABARANGPUR", "NAYAGARH", "NUAPADA",
    "PURI", "RAYAGADA", "SAMBALPUR", "SUBARNAPUR", "SUNDARGARH"
  ],
  "JHARKHAND": [
    "BOKARO", "CHATRA", "DEOGHAR", "DHANBAD", "DUMKA",
    "EAST SINGHBHUM (JAMSHEDPUR)", "GARHWA", "GIRIDIH", "GODDA", "GUMLA",
    "HAZARIBAG", "JAMTARA", "KHUNTI", "KODERMA", "LATEHAR",
    "LOHARDAGA", "PAKUR", "PALAMU", "RAMGARH", "RANCHI",
    "SAHIBGANJ", "SERAIKELA KHARSAWAN", "SIMDEGA", "WEST SINGHBHUM"
  ],
  "CHHATTISGARH": [
    "BALOD", "BALODA BAZAR", "BALRAMPUR", "BASTAR", "BEMETARA",
    "BIJAPUR", "BILASPUR", "DANTEWADA", "DHAMTARI", "DURG",
    "GARIYABAND", "GAURELA-PENDRA-MARWAHI", "JANJGIR-CHAMPA", "JASHPUR", "KABIRDHAM",
    "KANKER", "KONDAGAON", "KORBA", "KOREA", "MAHASAMUND",
    "MANENDRAGARH-CHIRMIRI-BHARATPUR", "MOHLA-MANPUR-AMBAGARH CHOWKI", "MUNGELI", "NARAYANPUR", "RAIGARH",
    "RAIPUR", "RAJNANDGAON", "SARANGARH-BILAIGARH", "SUKMA", "SURAJPUR",
    "SURGUJA"
  ],
  "ASSAM": [
    "BAKSA", "BARPETA", "BISWANATH", "BONGAIGAON", "CACHAR (SILCHAR)",
    "CHARAIDEO", "CHIRANG", "DARRANG", "DHEMAJI", "DHUBRI",
    "DIBRUGARH", "DIMA HASAO", "GOALPARA", "GOLAGHAT", "HAILAKANDI",
    "HOJAI", "JORHAT", "KAMRUP", "KAMRUP METROPOLITAN (GUWAHATI)", "KARBI ANGLONG",
    "KARIMGANJ", "KOKRAJHAR", "LAKHIMPUR", "MAJULI", "MORIGAON",
    "NAGAON", "NALBARI", "SIVASAGAR", "SONITPUR", "SOUTH SALMARA-MANKACHAR",
    "TINSUKIA", "UDALGURI", "WEST KARBI ANGLONG"
  ],
  "UTTARAKHAND": [
    "ALMORA", "BAGESHWAR", "CHAMOLI", "CHAMPAWAT", "DEHRADUN",
    "HARIDWAR", "NAINITAL", "PAURI GARHWAL", "PITHORAGARH", "RUDRA PRAYAG",
    "TEHRI GARHWAL", "UDHAM SINGH NAGAR", "UTTARKASHI"
  ],
  "HIMACHAL PRADESH": [
    "BILASPUR", "CHAMBA", "HAMIRPUR", "KANGRA (DHARAMSHALA)", "KINNAUR",
    "KULLU", "LAHAUL AND SPITI", "MANDI", "SHIMLA", "SIRMOUR",
    "SOLAN", "UNA"
  ],
  "GOA": [
    "NORTH GOA (PANAJI, MAPUSA)", "SOUTH GOA (MARGAO, VASCO)"
  ],
  "JAMMU AND KASHMIR": [
    "ANANTNAG", "BANDIPORA", "BARAMULLA", "BUDGAM", "DODA",
    "GANDERBAL", "JAMMU", "KATHUA", "KISHTWAR", "KULGAM",
    "KUPWARA", "POONCH", "PULWAMA", "RAJOURI", "RAMBAN",
    "REASI", "SAMBA", "SHOPIAN", "SRINAGAR", "UDHAMPUR"
  ],
  "LADAKH": [
    "KARGIL", "LEH"
  ],
  "CHANDIGARH": [
    "CHANDIGARH"
  ],
  "MANIPUR": [
    "BISHNUPUR", "CHANDEL", "CHURACHANDPUR", "IMPHAL EAST", "IMPHAL WEST",
    "JIRIBAM", "KAKCHING", "KAMJONG", "KANGPOKPI", "NONEY",
    "PHERZAWL", "SENAPATI", "TAMENGLONG", "TENGNOUPAL", "THOUBAL", "UKHRUL"
  ],
  "MEGHALAYA": [
    "EAST GARO HILLS", "EAST JAINTIA HILLS", "EAST KHASI HILLS (SHILLONG)", "NORTH GARO HILLS",
    "RI BHOI", "SOUTH GARO HILLS", "SOUTH WEST GARO HILLS", "SOUTH WEST KHASI HILLS",
    "WEST GARO HILLS (TURA)", "WEST JAINTIA HILLS", "WEST KHASI HILLS"
  ],
  "MIZORAM": [
    "AIZAWL", "CHAMPHAI", "HNAHTHIAL", "KHAWZAWL", "KOLASIB",
    "LAWNGTLAI", "LUNGLEI", "MAMIT", "SAITUAL", "SIAHA", "SERCHHIP"
  ],
  "NAGALAND": [
    "CHUMOUKEDIMA", "DIMAPUR", "KIPHIRE", "KOHIMA", "LONGLENG",
    "MOKOKCHUNG", "MON", "NIULAND", "NOKLAK", "PEREN",
    "PHEK", "SHAMATOR", "TUENSANG", "WOKHA", "ZUNHEBOTO"
  ],
  "SIKKIM": [
    "GANGTOK", "GYALSHING", "MANGAN", "NAMCHI", "PAK YONG", "SORENG"
  ],
  "TRIPURA": [
    "DHALAI", "GOMATI", "KHOWAI", "NORTH TRIPURA", "SEPAHIJALA",
    "SOUTH TRIPURA", "UNAKOTI", "WEST TRIPURA (AGARTALA)"
  ],
  "ARUNACHAL PRADESH": [
    "ANJAW", "CHANGLANG", "DIBANG VALLEY", "EAST KAMENG", "EAST SIANG",
    "ITANAGAR CAPITAL COMPLEX", "KAMLE", "KRA DAADI", "KURUNG KUMEY", "LEPA RADA",
    "LOHIT", "LONGDING", "LOWER DIBANG VALLEY", "LOWER SUBANSIRI", "NAMSAI",
    "PAKKE KESSANG", "PAPUM PARE", "SHI YOMI", "SIANG", "TAWANG",
    "TIRAP", "UPPER SIANG", "UPPER SUBANSIRI", "WEST KAMENG", "WEST SIANG"
  ],
  "ANDAMAN AND NICOBAR ISLANDS": [
    "NICOBAR", "NORTH AND MIDDLE ANDAMAN", "SOUTH ANDAMAN (PORT BLAIR)"
  ],
  "DADRA AND NAGAR HAVELI AND DAMAN AND DIU": [
    "DADRA AND NAGAR HAVELI (SILVASSA)", "DAMAN", "DIU"
  ],
  "LAKSHADWEEP": [
    "KAVARATTI", "AGATTI", "AMINI", "ANDROTT", "MINICOY"
  ],
  "PUDUCHERRY": [
    "KARAIKAL", "MAHE", "PUDUCHERRY", "YANAM"
  ]
};

// Sorted list of all state names
export const ALL_INDIAN_STATES = Object.keys(INDIAN_STATES_DISTRICTS).sort();

// Combined sorted list of all districts across India
export const ALL_INDIAN_DISTRICTS = Array.from(
  new Set(Object.values(INDIAN_STATES_DISTRICTS).flat())
).sort();

// Official Proof of Identity Dropdown Options
export const PROOF_OF_IDENTITY_OPTIONS = [
  "Certificate of Identity signed by Gazetted Officer",
  "Certificate of Identity signed by MLA",
  "Certificate of Identity signed by MP",
  "Certificate of Identity signed by Municipal Councillor",
  "Driving License",
  "Passport",
  "Central Government Health Scheme Card",
  "Transgender Identity Card / Certificate",
  "Ex-Servicemen Contributory Health Scheme Card",
  "Bank Certificate in Original on Official Letterhead",
  "Photo ID Card issued by Govt / PSU",
  "Pensioner Card with Photograph",
  "Elector's Photo Identity Card (Voter ID)",
  "Ration Card with Photograph",
  "AADHAAR Card (UIDAI)",
  "Armed Forces Equalisation / Defence ID Card",
  "ABHA Health Govt ID Card"
];

// Official Proof of Address Dropdown Options
export const PROOF_OF_ADDRESS_OPTIONS = [
  "Latest Property Tax Assessment Order",
  "Depository Account Statement (< 3 months old)",
  "Credit Card Statement (< 3 months old)",
  "Bank Account Statement / Passbook (< 3 months old)",
  "Landline Telephone Bill (< 3 months old)",
  "Certificate of Address signed by Municipal Councillor",
  "Driving License",
  "Passport",
  "Property Registration Document",
  "Electricity Bill (< 3 months old)",
  "Bank Account Statement (Country of Residence)",
  "NRE Bank Account Statement (< 3 months old)",
  "Employer Certificate in Original",
  "Elector's Photo Identity Card (Voter ID)",
  "Certificate of Address signed by Gazetted Officer",
  "Passport of Spouse",
  "Post Office Passbook with Address",
  "AADHAAR Card (UIDAI)",
  "Certificate of Address signed by MP",
  "Certificate of Address signed by MLA",
  "Water Bill (< 3 months old)",
  "Consumer Gas Connection Card / Pipe Gas Bill",
  "Domicile Certificate issued by Government",
  "Allotment Letter of Accommodation (Govt)"
];

// Official Proof of Date of Birth Dropdown Options
export const PROOF_OF_DOB_OPTIONS = [
  "Birth Certificate (Municipal Authority / Registrar)",
  "Pension Payment Order",
  "Marriage Certificate (Registrar of Marriages)",
  "Matriculation Certificate / Marksheet",
  "Driving License",
  "Domicile Certificate issued by Government",
  "Affidavit sworn before Magistrate",
  "Elector's Photo Identity Card (Voter ID)",
  "Photo ID Card issued by Govt / PSU",
  "Central Government Health Scheme Card",
  "Ex-Servicemen Contributory Health Scheme Card",
  "Passport",
  "ABHA Health Govt ID Card",
  "AADHAAR Card (UIDAI)"
];

